import esEs from 'antd/lib/locale/es_ES';
import enUS from 'antd/lib/locale/en_US';
import ptBr from 'antd/lib/locale/pt_BR';
import { Locale } from 'antd/es/locale-provider';
import { LANGUAGE_ENUM } from '../i18n/config';

export interface ObjectKey<T> {
  [key: string]: T;
}
export const getLocale = (lng: string = LANGUAGE_ENUM.es): Locale => {
  const locale: ObjectKey<Locale> = {
    [LANGUAGE_ENUM.en]: enUS,
    [LANGUAGE_ENUM.es]: esEs,
    [LANGUAGE_ENUM['pt-BR']]: ptBr
  };
  return locale[lng];
};
